const LINKS_SELECTOR = "[data-apply-section-link]";

document.addEventListener("click", (e: MouseEvent) => {
  // Only intercept left-click without modifier keys
  if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;

  const link = (e.target as HTMLElement).closest<HTMLAnchorElement>(LINKS_SELECTOR);
  if (!link) return;

  e.preventDefault();

  const scrollPos = window.scrollY;
  if (scrollPos == 0) return;

  const url = new URL(link.href);
  url.searchParams.set("scrollpos", scrollPos.toString());

  // Start the smooth view transition if supported
  if ("startViewTransition" in document) {
    (document as any).startViewTransition(() => {
      window.location.href = url.toString();
    });
  } else {
    // fallback if startViewTransition is not supported
    window.location.href = url.toString();
  }
});

function restoreScrollFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const scrollParam = params.get("scrollpos");
  if (!scrollParam) return;

  const scrollPos = Number(scrollParam);
  if (!Number.isFinite(scrollPos)) return;

  const previousScrollBehavior = document.documentElement.style.scrollBehavior;

  // Force instant jump
  document.documentElement.style.scrollBehavior = "auto";
  window.scrollTo(0, scrollPos);

  // Restore scroll behavior
  requestAnimationFrame(() => {
    document.documentElement.style.scrollBehavior = previousScrollBehavior;
  });

  // Clean URL
  params.delete("scrollpos");
  const cleanUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : "") + window.location.hash;
  history.replaceState(null, "", cleanUrl);
}

restoreScrollFromUrl();
